import AuthLayout from '@/app/layout/authLayout'
import { InvitationAcceptForm } from '@/app/entities/orgInvitations/ui'

export const Invitation = () => {
    return (
        <AuthLayout>
            <InvitationAcceptForm />
        </AuthLayout>
    )
}
